export const etapas = [
  {
    titulo: "Identificação da empreendedora",
    descricao: "Vamos conhecer você e as características do seu negócio.",
    campos: [
      ["nome_completo", "1. Nome completo", "text"],
      ["nome_negocio", "2. Nome do negócio/marca", "text"],
      ["whatsapp", "3. Telefone/WhatsApp", "tel"],
      ["instagram", "4. Instagram ou outra rede social", "text"],
      ["area_atuacao", "5. Área principal de atuação", "select", [
        "Alimentação/gastronomia",
        "Moda/vestuário",
        "Beleza e estética",
        "Artesanato/economia criativa",
        "Comércio",
        "Serviços",
        "Educação",
        "Saúde/bem-estar",
        "Tecnologia",
        "Comunicação/marketing",
        "Turismo",
        "Outro"
      ]],
      ["tempo_negocio", "6. Há quanto tempo o negócio existe?", "select", [
        "Menos de 6 meses",
        "6 meses a 1 ano",
        "1 a 2 anos",
        "2 a 5 anos",
        "Mais de 5 anos"
      ]],
      ["formalizacao", "7. Situação atual do negócio", "select", [
        "Informal",
        "MEI",
        "Microempresa",
        "Outra formalização"
      ]],
      ["equipe", "8. Atualmente você trabalha", "select", [
        "Sozinha",
        "Com familiares",
        "Com 1 ou 2 colaboradoras",
        "Com 3 ou mais colaboradoras"
      ]]
    ]
  },
  {
    titulo: "Raio-X do meu negócio",
    descricao: "Pense na realidade atual do seu negócio. Não precisa escrever respostas perfeitas: o objetivo é enxergar o negócio com clareza.",
    campos: [
      ["produtos", "9. O que seu negócio vende?", "textarea"],
      ["clientes", "10. Quem é sua principal cliente?", "textarea"],
      ["necessidade_cliente", "11. Qual problema, necessidade ou desejo seu negócio resolve para essa cliente?", "textarea"],
      ["valor", "12. Por que sua cliente compra de você e não de outra pessoa?", "textarea"],
      ["pontos_fortes", "13. Quais são hoje os principais pontos fortes do seu negócio?", "textarea"],
      ["dificuldades", "14. Quais são hoje os três principais problemas ou dificuldades do negócio?", "textarea"]
    ]
  },
  {
    titulo: "Diagnóstico do negócio",
    descricao: "Para cada afirmação, marque a situação que melhor representa seu negócio hoje.",
    campos: [
      ["diag_clientes", "Conheço minha cliente.", "escala"],
      ["diag_oferta", "Tenho clareza do que vendo.", "escala"],
      ["diag_diferencial", "Tenho um diferencial percebido.", "escala"],
      ["diag_produtos", "Meus produtos/serviços estão organizados.", "escala"],
      ["diag_marca", "Minha marca e minha comunicação representam meu negócio.", "escala"],
      ["diag_canais", "Tenho canais de divulgação e venda funcionando.", "escala"],
      ["diag_financas", "Tenho controle financeiro.", "escala"],
      ["diag_metas", "Tenho metas e acompanho os resultados.", "escala"]
    ]
  },
  {
    titulo: "Priorização: onde posso transformar?",
    descricao: "Primeiro, marque as áreas em que identifica maior necessidade de melhoria. Depois, escolha até três prioridades.",
    campos: [
      ["areas_prioritarias", "Quais áreas precisam melhorar?", "multipla", [
        "Produto/serviço",
        "Atendimento/experiência da cliente",
        "Marca/apresentação",
        "Divulgação e conteúdo",
        "WhatsApp/vendas",
        "Novos canais de venda",
        "Processos/organização",
        "Gestão financeira",
        "Digitalização",
        "Inteligência Artificial",
        "Parcerias",
        "Outro"
      ]],
      ["prioridade_1", "15. Primeira prioridade para os próximos meses", "textarea"],
      ["prioridade_2", "Segunda prioridade", "textarea"],
      ["prioridade_3", "Terceira prioridade", "textarea"],
      ["oportunidade_inovacao", "16. Qual é a maior oportunidade de melhoria ou inovação que você enxerga hoje?", "textarea"]
    ]
  },
  {
    titulo: "Proposta de valor, produto e serviço",
    descricao: "Identifique o valor que seu negócio oferece e as oportunidades de melhoria nos produtos e serviços.",
    campos: [
      ["proposta_valor", "17. Minha cliente escolhe meu negócio porque eu ofereço... para ajudá-la a...", "textarea"],
      ["principal_produto", "18. Quais são meus principais produtos ou serviços?", "textarea"],
      ["mapa_produtos", "18.1. Mapa rápido de produtos/serviços", "tabela_produtos"],
      ["melhorias_produtos", "19. Existe algum produto ou serviço que deveria ser:", "multipla", [
        "Melhor apresentado",
        "Reformulado",
        "Renomeado",
        "Retirado",
        "Criado",
        "Transformado em pacote/combo",
        "Melhor precificado",
        "Divulgado de outra forma"
      ]],
      ["mudanca_produtos", "20. Qual será a principal mudança neste eixo?", "textarea"]
    ]
  },
  {
    titulo: "Marca, comunicação e presença digital",
    descricao: "Vamos avaliar como sua marca é percebida, como você se comunica e quais ferramentas digitais utiliza.",
    campos: [
      ["identidade_marca", "21. Como você acredita que sua marca é percebida hoje pelas clientes?", "textarea"],
      ["percepcao_desejada", "22. Como você gostaria que sua marca fosse percebida?", "textarea"],
      ["historia_negocio", "23. Qual história do seu negócio pode gerar conexão com suas clientes?", "textarea"],
      ["divulgacao", "24. Quais ferramentas digitais você utiliza atualmente?", "multipla", [
        "Instagram",
        "WhatsApp",
        "TikTok",
        "Nenhuma ferramenta digital",
        "Facebook",
        "WhatsApp Business",
        "Google",
        "Outra"
      ]],
      ["melhorias_comunicacao", "25. O que precisa melhorar na sua vitrine digital ou comunicação?", "textarea"],
      ["conteudos_vendas", "26. Que tipo de conteúdo você poderia produzir para gerar mais vendas?", "textarea"],
      ["digital_ia", "27. Qual tarefa do seu negócio poderia ser facilitada por uma ferramenta digital ou Inteligência Artificial?", "textarea"],
      ["mudanca_comunicacao", "28. Qual será a principal mudança neste eixo?", "textarea"]
    ]
  },
  {
    titulo: "Vendas, atendimento e WhatsApp",
    descricao: "Vamos entender como suas clientes chegam, como acontece o atendimento e onde existem oportunidades para melhorar as vendas.",
    campos: [
      ["canais_venda", "29. Como a cliente chega até o seu negócio?", "textarea"],
      ["atendimento", "30. Como acontece o atendimento desde o primeiro contato até a venda?", "textarea"],
      ["etapa_perda_clientes", "31. Em qual etapa você acredita que perde mais clientes?", "select", [
        "Divulgação",
        "Antes do primeiro contato",
        "Durante o atendimento",
        "Apresentação do produto/serviço",
        "Preço",
        "Fechamento",
        "Pagamento",
        "Pós-venda",
        "Não sei identificar"
      ]],
      ["melhorias_vendas", "32. O que você precisa mudar no seu processo de vendas?", "textarea"],
      ["pos_venda", "33. Que ação de pós-venda você pode implementar para fortalecer o relacionamento com suas clientes?", "textarea"]
    ]
  },
  {
    titulo: "Gestão financeira e crescimento",
    descricao: "Vamos avaliar a organização financeira do negócio e identificar oportunidades para crescer.",
    campos: [
      ["separa_financas", "34. Você separa o dinheiro pessoal do dinheiro do negócio?", "select", [
        "Sim", "Parcialmente", "Não"
      ]],
      ["controle_financeiro", "35. Você controla quanto vende por mês?", "select", [
        "Sim", "Parcialmente", "Não"
      ]],
      ["conhece_custos", "36. Você conhece os custos dos seus produtos ou serviços?", "select", [
        "Sim", "Parcialmente", "Não"
      ]],
      ["conhece_lucro", "37. Você sabe quanto lucra em cada venda?", "select", [
        "Sim", "Parcialmente", "Não"
      ]],
      ["meta_vendas", "38. Você possui uma meta de vendas?", "select", [
        "Sim", "Não"
      ]],
      ["mudanca_financeira", "39. Qual é a principal mudança financeira que você precisa fazer?", "textarea"],
      ["metas_crescimento", "40. Qual é sua principal meta de crescimento?", "textarea"]
    ]
  },
  {
    titulo: "Meu plano de transformação",
    descricao: "Com base no diagnóstico e nas prioridades escolhidas, defina as ações que serão realizadas para transformar seu negócio.",
    campos: [
      [
        "plano_transformacao_tabela",
        "Plano de ação: o que vamos transformar no negócio?",
        "tabela_transformacao"
      ]
    ]
  },
  {
    titulo: "Indicadores de acompanhamento",
    descricao: "Escolha de 3 a 5 indicadores para acompanhar a evolução do seu negócio.",
    campos: [
      ["indicadores_escolhidos", "Quais indicadores você deseja acompanhar? Escolha de 3 a 5.", "multipla", [
        "Vendas",
        "Número de clientes",
        "Ticket médio",
        "Alcance/seguidores",
        "Pedidos pelo WhatsApp",
        "Novos produtos/serviços",
        "Lucro/margem",
        "Clientes recorrentes",
        "Outro"
      ]],
      [
        "indicadores_tabela",
        "Defina a situação atual, a meta e como acompanhar cada indicador.",
        "tabela_indicadores"
      ]
    ]
  },
  {
    titulo: "Compromissos de 30, 60 e 90 dias",
    descricao: "Defina os compromissos que ajudarão a colocar seu plano de transformação em prática.",
    campos: [
      [
        "compromisso_30_dias",
        "O que vou realizar nos próximos 30 dias?",
        "textarea"
      ],
      [
        "compromisso_60_dias",
        "O que vou realizar nos próximos 60 dias?",
        "textarea"
      ],
      [
        "compromisso_90_dias",
        "O que vou realizar nos próximos 90 dias?",
        "textarea"
      ]
    ]
  },
  {
    titulo: "Acompanhamento da mentoria",
    descricao: "Registre a evolução do negócio, os aprendizados e a validação do acompanhamento realizado.",
    campos: [
      [
        "mentoria_evolucao",
        "Observações da mentoria e evolução do negócio",
        "textarea"
      ],
      [
        "mentoria_proximos_passos",
        "Continuidade e próximos passos",
        "textarea"
      ],
      [
        "mentoria_resultados",
        "Aprendizados e resultados alcançados",
        "textarea"
      ],
      [
        "validacao_empreendedora",
        "Nome da empreendedora para validação",
        "text"
      ],
      [
        "data_validacao_empreendedora",
        "Data da validação da empreendedora",
        "date"
      ],
      [
        "validacao_mentora",
        "Nome da mentora para validação",
        "text"
      ],
      [
        "data_validacao_mentora",
        "Data da validação da mentora",
        "date"
      ]
    ]
  }
];
